import { jsx } from 'react/jsx-runtime';
import { StoreInit } from '../store/init/index.js';

function ThemeConfig(props) {
  return /* @__PURE__ */ jsx(StoreInit, { ...props });
}
ThemeConfig.displayName = "ThemeConfig";

export { ThemeConfig };
//# sourceMappingURL=config.js.map
